export type PasswordRuleId =
  | 'minLength'
  | 'uppercase'
  | 'lowercase'
  | 'number'
  | 'special';

export interface PasswordRule {
  id: PasswordRuleId;
  label: string;
  test: (password: string) => boolean;
}

/** Matches tenant-fe Yup password policy (complexity rules). */
export const PASSWORD_RULES: PasswordRule[] = [
  {
    id: 'minLength',
    label: 'Minimum 8 characters',
    test: (password) => password.length >= 8,
  },
  {
    id: 'uppercase',
    label: 'Uppercase',
    test: (password) => /[A-Z]/.test(password),
  },
  {
    id: 'lowercase',
    label: 'Lowercase',
    test: (password) => /[a-z]/.test(password),
  },
  {
    id: 'number',
    label: 'Number',
    test: (password) => /[0-9]/.test(password),
  },
  {
    id: 'special',
    label: 'Special character',
    // Any non-letter/non-digit: \W is [^A-Za-z0-9_]; underscore is listed
    // separately because it is a word character. No further charset limit.
    test: (password) => /[\W_]/.test(password),
  },
];

export const getPasswordRuleStates = (password: string): Record<PasswordRuleId, boolean> => {
  return PASSWORD_RULES.reduce(
    (states, rule) => {
      states[rule.id] = rule.test(password);
      return states;
    },
    {} as Record<PasswordRuleId, boolean>
  );
};

export const arePasswordRulesMet = (password: string): boolean => {
  return PASSWORD_RULES.every((rule) => rule.test(password));
};
